import { render, staticRenderFns } from "./AdminSentInstructionsNotes_2.vue?vue&type=template&id=3d851b08&scoped=true"
import script from "./AdminSentInstructionsNotes_2.vue?vue&type=script&lang=js"
export * from "./AdminSentInstructionsNotes_2.vue?vue&type=script&lang=js"
import style0 from "./AdminSentInstructionsNotes_2.vue?vue&type=style&index=0&id=3d851b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d851b08",
  null
  
)

export default component.exports